import React, { Component } from 'react';
import { Button, Input, Select, DatePicker, InputNumber } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import API_URL from '../../../common/url';
import SearchMulRetrieve from '../../common/SearchMulRetrieve.js';

const InputGroup = Input.Group;
const Option = Select.Option;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { params } = props;
        this.state = { 
            searchParams: { ...params },
        };
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    handleChange = (value, key, option) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'customerCompany': {
                let customerCompanyOption = searchParams[`${key}Ids`] ? searchParams[`${key}Ids`].split(',') : [];
                if (option) {
                    customerCompanyOption.push(option.value);
                } else {
                    customerCompanyOption = customerCompanyOption.filter(i => i != value);
                }
                searchParams[`${key}Ids`] = customerCompanyOption.join(',');
                break;
            }
            default:
                searchParams[key] = value;
                break;
        }
        this.setState({ searchParams });
    }

    showFixedLine = () => {
        this.props.showFixedLine();
    }

    render() {
        const { curRole, invId } = sessionStorage;
        const { searchParams } = this.state;
        const { contractRequestFinish, PmContractRequestFinish, applyProjectFinish } = this.props;
        const { jdeContractAmountSymbol, startTimeSymbol, endTimeSymbol, jdeCode, customerCompanyIds } = searchParams;
        const customerCompanyList = customerCompanyIds ? customerCompanyIds.split(',') : [];
        return (
            <div className="search-bar bar2" style={{ marginBottom: 16 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">JDE项目号</label>
                    <Input
                        style={{ width: 110 }}
                        placeholder="请输入"
                        value={jdeCode}
                        onChange={e => this.handleChange(e.target.value, 'jdeCode')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">名称(ProjectID)</label>
                    <Input placeholder="请输入" onChange={e => this.handleChange(e.target.value, 'projectIdName')} />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">中心</label>
                    <Input
                        style={{ width: 140 }}
                        placeholder="请输入中心或编号"
                        onChange={e => this.handleChange(e.target.value, 'keyword')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">合同额含税/人民币(元)</label>
                    <InputGroup compact>
                        <Select value={jdeContractAmountSymbol} onChange={value => this.handleChange(value, 'jdeContractAmountSymbol')}>
                            <Option value="Equals">=</Option>
                            <Option value="GreatThan">&gt;</Option>
                            <Option value="NotLess">&ge;</Option>
                            <Option value="LessThan">&lt;</Option>
                            <Option value="NotGreat">&le;</Option>
                        </Select>
                        <InputNumber
                            style={{ width: 110 }}
                            placeholder="请输入"
                            onChange={value => this.handleChange(value, 'jdeContractAmount')}
                        />
                    </InputGroup>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">合同开始时间</label>
                    <span>
                        <InputGroup compact>
                            <Select
                                value={startTimeSymbol}
                                onChange={value => this.handleChange(value, 'startTimeSymbol')}
                            >
                                <Option value="Equals">=</Option>
                                <Option value="GreatThan">&gt;</Option>
                                <Option value="NotLess">&ge;</Option>
                                <Option value="LessThan">&lt;</Option>
                                <Option value="NotGreat">&le;</Option>
                            </Select>
                            <DatePicker style={{ width: 110 }} onChange={(date, dateString) => this.handleChange(dateString, 'startTime')} />
                        </InputGroup>
                    </span>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">合同结束时间</label>
                    <span>
                        <InputGroup compact>
                            <Select
                                value={endTimeSymbol}
                                onChange={value => this.handleChange(value, 'endTimeSymbol')}
                            >
                                <Option value="Equals">=</Option>
                                <Option value="GreatThan">&gt;</Option>
                                <Option value="NotLess">&ge;</Option>
                                <Option value="LessThan">&lt;</Option>
                                <Option value="NotGreat">&le;</Option>
                            </Select>
                            <DatePicker style={{ width: 110 }} onChange={(date, dateString) => this.handleChange(dateString, 'endTime')} />
                        </InputGroup>
                    </span>
                </div>
                {/* <div className="search-item">
                    <label htmlFor="" className="ui-label">合同请款完成情况</label>
                    <span>
                        <Select
                            allowClear
                            style={{ width: 120 }}
                            placeholder="请选择"
                            className="left-frame"
                            onChange={value => this.handleChange(value, 'remittanceCompletedInfo')}
                        >
                            <Option value="Unconfirmed">未确认</Option>
                            <Option value="Tobe_PM_Confirmed">待PM确认</Option>
                            <Option value="PM_Reject_Confirmed">PM拒绝确认</Option>
                            <Option value="Tobe_FIN_Confirmed">待FIN确认</Option>
                            <Option value="FIN_Reject_Confirmed">FIN拒绝确认</Option>
                            <Option value="FIN_Confirmed">FIN已确认</Option>
                        </Select>
                    </span>
                </div> */}
                <div className="search-item">
                    <label className="ui-label">客户全名</label>
                    <SearchMulRetrieve
                        keyword='customerCompanyName'
                        style={{ width: 162 }}
                        placeholder="输入名称检索"
                        value={customerCompanyList}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={(value, option) => this.handleChange(value, 'customerCompany', option)}
                    />
                </div>
                <div className="search-item">
                        <label className="ui-label">是否据实结算</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={searchParams.isRealitySettle}
                            onChange={value => this.handleChange(value, 'isRealitySettle')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">MSA特殊优惠是否从合同额中扣减</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={searchParams.isMsaSpecialContractReduce}
                            onChange={value => this.handleChange(value, 'isMsaSpecialContractReduce')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.showFixedLine} style={{ background: '#fc0', border: '1px solid #f93' }}>导出固化数据</Button>
                    {/* { curRole === 'PM' && (
                        PmContractRequestFinish ?
                            <Button type="primary" onClick={() => applyProjectFinish('PM')}>确认项目请款完成</Button>
                        :
                            <Button disabled={true}>确认项目请款完成</Button>
                        )
                    }
                    {
                        (curRole === 'CSA' || curRole === 'CSAL') && (  
                            contractRequestFinish ? 
                                <Button type="primary" onClick={() => applyProjectFinish('BA')}>申请项目请款完成</Button>
                            :
                                <Button disabled={true}>申请项目请款完成</Button>
                            )
                    } */}
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/projectContract/contractRecord/Filter.js